module.exports = __webpack_public_path__ + "static/media/devuelto.fadd7b9d.svg";